import theme, { makeStyles } from 'core/utilities/theme';

interface MakeStylesProps {
  hoverColor?: string;
}

export default makeStyles((props: MakeStylesProps) => ({
  commands: {
    // in order: links, buttons, toggleButton single, toggleButton dropdown
    '& > a, > button, > div[role="group"] button, > div div[role="group"] button': {
      marginLeft: theme.spacing(0.5),
    },
    '& > div[role="group"]': {
      verticalAlign: 'middle',
    },
  },
  commandsHover: {
    '& > a, > button': {
      '&:hover': {
        backgroundColor: `${props.hoverColor || ''} !important`,
      },
    },
  },
}));
